import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { LoginComponent } from 'src/modules/kx-shared/components/login/login.component';
import { patientMenuDef } from 'src/definitions/patient-registration/menuDef';
import { patientRouteDef } from 'src/definitions/patient-registration/routeDef';
import { adtMenuDef } from 'src/definitions/adt/menuDef';
import { adtRouteDef } from 'src/definitions/adt/routeDef';
import { emergencyMenuDef } from 'src/definitions/emergency/menuDef';
import { emergencyRouteDef } from 'src/definitions/emergency/routeDef';
import { mrdMenuDef } from 'src/definitions/mrd/menuDef';
import { mrdRouteDef } from 'src/definitions/mrd/routeDef';
import { emrMenuDef } from 'src/definitions/emr/menuDef';
import { emrRouteDef } from 'src/definitions/emr/routeDef';
import { demoapplicationRouteDef } from 'src/definitions/demo-application/routeDef';
import { demoapplicationMenuDef } from 'src/definitions/demo-application/menuDef';
import { accountManagementMenuDef } from 'src/definitions/account-management/menuDef';
import { accountManagementRouteDef } from 'src/definitions/account-management/routeDef';
import { kxinsightsMenuDef } from 'src/definitions/kxinsights/menuDef';
import { kxinsightsRouteDef } from 'src/definitions/kxinsights/routeDef';
import { facilityManagementMenuDef } from 'src/definitions/facility-management/menuDef';
import { facilityManagementRouteDef } from 'src/definitions/facility-management/routeDef';
import { billingRouteDef } from 'src/definitions/billing/routeDef';
import { billingMenuDef } from 'src/definitions/billing/menuDef';
import { diagnosticRouteDef } from 'src/definitions/diagnostic/routeDef';
import { diagnosticMenuDef } from 'src/definitions/diagnostic/menuDef';
import { bpmnRouteDef } from 'src/definitions/bpmn/routeDef';
import { bpmnMenuDef } from 'src/definitions/bpmn/menuDef';
//import { sampleRouteDef } from 'src/definitions/sample-layout/routeDef';
//import { sampelMenuDef } from 'src/definitions/sample-layout/menuDef';
import { inventoryMenuDef } from 'src/definitions/inventory-management/menuDef';
import { inventoryRouteDef } from 'src/definitions/inventory-management/routeDef';
import { paymentMenuDef } from 'src/definitions/payment/menuDef';
import { paymentRouteDef } from 'src/definitions/payment/routeDef';
import { seriespatternRouteDef } from 'src/definitions/seriespattern/routeDef';
import { seriespatternMenuDef } from 'src/definitions/seriespattern/menuDef';
import { nhmMenuDef } from 'src/definitions/nhm-reports/menuDef';
import { nhmRouteDef } from 'src/definitions/nhm-reports/routeDef';

import { systemManagementMenuDef } from 'src/definitions/system-management/menuDef';
import { systemManagementRouteDef } from 'src/definitions/system-management/routeDef';
import { houseKeepingMenuDef } from 'src/definitions/house-keeping/menuDef';
import { houseKeepingRouteDef } from 'src/definitions/house-keeping/routeDef';
import { dietKitchenMenuDef } from 'src/definitions/diet-kitchen/menuDef';
import { dietKitchenRouteDef } from 'src/definitions/diet-kitchen/routeDef';
import { CssdMenuDef } from 'src/definitions/cssd/menuDef';
import { CssdRouteDef } from 'src/definitions/cssd/routeDef';
import { systemSettingsMenuDef } from 'src/definitions/system-settings/menuDef';
import { systemSettingsRouteDef } from 'src/definitions/system-settings/routeDef';
import { LinenLaundryRouteDef } from 'src/definitions/linen-laundry/routeDef';
import { LinenLaundryMenuDef } from 'src/definitions/linen-laundry/menuDef';
import { pharmacyMenuDef } from 'src/definitions/pharmacy/menuDef';
import { pharmacyRouteDef } from 'src/definitions/pharmacy/routeDef';
import { BaseComponent } from 'src/modules/base/base.component';
import { appointmentMenuDef } from '../definitions/appointment/menuDef';
import { appointmentRouteDef } from '../definitions/appointment/routeDef';
import { DashBoardComponent } from 'src/modules/base/components/dash-board/dash-board.component';
import { LoginGuard } from 'src/modules/base/guards/login.gaurd';
import { AuthGuard } from 'src/modules/base/guards/auth.gaurd';
import { ExternalAppGuard } from './external-app.guard';
import { templateMenuDef } from 'src/definitions/template/menuDef';
import { templateRouteDef } from 'src/definitions/template/routeDef';
import { otMenuDef } from 'src/definitions/ot/menuDef';
import { otRouteDef } from 'src/definitions/ot/routeDef';
import { ambulanceMenuDef } from 'src/definitions/ambulance-management/menuDef';
import { ambulanceRouteDef } from 'src/definitions/ambulance-management/routeDef';
import { alertMenuDef } from 'src/definitions/alertmanager/menuDef';
import { alertRouteDef } from 'src/definitions/alertmanager/routeDef';
// import { TelemedecineComponent } from 'src/modules/kx-shared/components/telemedicine/telemedecine.component';
import { orderMenuDef } from 'src/definitions/order/menuDef';
import { orderRouteDef } from 'src/definitions/order/routeDef';
// import { ForgotPasswordComponent } frosrc/modules/account-management/components/forgot-password/forgot-password.componentent';
import { ChangePasswordComponent } from 'src/modules/account-management/components/change-password/change-password.component';
import { P404Component } from 'src/modules/base/error/404.component';
import { P500Component } from 'src/modules/base/error/500.component';
import { queueViewMenuDef } from 'src/definitions/queue-management/menuDef';
import { queueViewRouteDef } from 'src/definitions/queue-management/routeDef';
import { schedulerMenuDef } from 'src/definitions/scheduler/menuDef';
import { schedulerRouteDef } from 'src/definitions/scheduler/routeDef';
import { integratorMenuDef } from 'src/definitions/integrator/menuDef';
import { integratorRouteDef } from 'src/definitions/integrator/routeDef';
import { dmsRouteDef } from 'src/definitions/dms/routeDef';
import { dmsMenuDef } from 'src/definitions/dms/menuDef';
import { formBuilderMenuDef } from 'src/definitions/formBuilder/menuDef';
import { formBuilderRouteDef } from 'src/definitions/formBuilder/routeDef';
import { misReportsMenuDef } from 'src/definitions/misreports/menuDef';
import { misReportsRouteDef } from 'src/definitions/misreports/routeDef';
import { PaytmRedirectComponent } from 'src/modules/kx-shared/components/paytm-redirect/paytm-redirect.component';
// import { builderMenuDef } from 'src/definitions/builder/menuDef';
// import { builderRouteDef } from 'src/definitions/builder/routeDef';
import { DataOnBoardingMenuDef } from 'src/definitions/data-onboarding/menuDef';
import { DataOnBoardingRouteDef } from 'src/definitions/data-onboarding/routeDef';
// import { TelemedicineComponent } from 'src/modules/telemedicine/components/telemedicine/telemedicine.component';
import { myBillsMenuDef } from 'src/definitions/mybills/menuDef';
import { myBillsRouteDef } from 'src/definitions/mybills/routeDef'
import { discoveryMenuDef } from 'src/definitions/discovery/menuDef';
import { discoveryRouteDef } from 'src/definitions/discovery/routeDef';
import { insuranceMenuDef } from 'src/definitions/insurance/menuDef';
import { insuranceRouteDef } from 'src/definitions/insurance/routeDef';
import { opticalMenuDef } from 'src/definitions/optical/menuDef';
import { opticalRouteDef } from 'src/definitions/optical/routeDef';
import { SupportComponent } from 'src/modules/kx-shared/components/support/support.component';
import { OfflineComponent } from 'src/modules/base/error/offline.component';
import { LoginComponent } from 'src/modules/account-management/components/login/login.component';
import { ForgotPasswordComponent } from 'src/modules/account-management/components/forgot-password/forgot-password.component';
import {ReportManagementMenuDef} from 'src/definitions/report-management/menuDef';
import {ReportManagementRouteDef} from 'src/definitions/report-management/routeDef';
import {ruleEngineMenuDef} from 'src/definitions/rule-engine/menuDef';
import {ruleEngineRouteDef} from 'src/definitions/rule-engine/routeDef';
import { printengineMenuDef } from 'src/definitions/printengine/menuDef';
import { printengineRouteDef } from 'src/definitions/printengine/routeDef';
import { paymentGatewayMenuDef } from 'src/definitions/payment-gateway/menuDef';
import { paymentGatewayRouteDef } from 'src/definitions/payment-gateway/routeDef';
import { LandingUrlComponent } from 'src/modules/account-management/components/landing-url/landing-url.component';
import { DeviceAuthComponent } from 'src/modules/account-management/components/device-auth/device-auth.component';
import { bloodBankMenuDef } from 'src/definitions/blood-bank/menuDef';

import { bloodBankRouteDef } from 'src/definitions/blood-bank/routeDef';
import { TelemedicineGuestPageComponent } from 'src/modules/telemedicine/components/telemedicine-guest-page/telemedicine-guest-page.component';
import { misBuilderMenuDef } from 'src/definitions/misbuilder/menuDef';
import { misBuilderRouteDef } from 'src/definitions/misbuilder/routeDef';
import { abdmintegratorMenuDef } from 'src/definitions/abdm-integration/menuDef';
import { abdmintegratorRouteDef } from 'src/definitions/abdm-integration/routeDef';
import { PinAuthenticatedComponent } from 'src/modules/account-management/components/pin-authentication/pin-authenticated.component';
// import { TesseractComponent } from 'src/modules/base/components/tesseract/tesseract.component';
import { QuickDownloadComponent } from 'src/modules/base/components/quick-download/quick-download.component';
import { QuickOTPComponent } from 'src/modules/account-management/components/quick-otp/quick-otp.component';
import { TesseractComponent } from 'src/modules/base/components/tesseract/tesseract.component';
import  {walletMenuDef} from 'src/definitions/wallet/menuDef';
import {walletRouteDef} from 'src/definitions/wallet/routeDef';
import { masterManagementMenuDef } from 'src/definitions/master-management/menuDef';
import { masterManagementRouteDef } from 'src/definitions/master-management/routeDef';
import { QuickMobileOtpComponent } from 'src/modules/account-management/components/quick-mobile-otp/quick-mobile-otp.component';

import { crmMenuDef } from 'src/definitions/crm/menuDef';
import { crmRouteDef } from 'src/definitions/crm/routeDef';
import { chatbotMenuDef } from 'src/definitions/chatbot/menuDef';
import { chatbotRouteDef } from 'src/definitions/chatbot/routeDef';
import { biReportsMenuDef } from 'src/definitions/biReports/menuDef';
import { biReportsRouteDef } from 'src/definitions/biReports/routeDef';
import { QRLoginComponent } from 'src/modules/account-management/components/qr-login/qr-login.component';
import { QRScannerComponent } from 'src/modules/account-management/components/qr-scanner/qr-scanner.component';
import { serviceWorkflowMenuDef } from 'src/definitions/serviceworkflow/menuDef';
import { serviceWorkflowRouteDef } from 'src/definitions/serviceworkflow/routeDef';
import { aiMlGatewayMenuDef } from 'src/definitions/aiml-gateway/menuDef';
import { aiMlGatewayRouteDef } from 'src/definitions/aiml-gateway/routeDef';
import { opsMgmtMenuDefs } from 'src/definitions/opsmgmt/menuDefs';
import { opsMgmtRouteDefs } from 'src/definitions/opsmgmt/routeDefs';
import { carePlanMenuDef } from 'src/definitions/care-plan/menuDef';
import { carePlanRouteDef } from 'src/definitions/care-plan/routeDef';
import { OnlinePaymentGuestComponent } from 'src/modules/account-management/components/online-payment-guest/online-payment-guest.component';
import { ReleaseNoteComponent } from 'src/modules/base/components/release-note/release-note.component';
import { TncComponent } from 'src/modules/base/components/tnc/tnc.component';
import { helpdeskmgmtRouteDef } from 'src/definitions/helpdeskmgmt/routeDef';

const routes: Routes = [
  { path: '', redirectTo: 'account-management/login', pathMatch: 'full' },
  { path: 'login', redirectTo: 'account-management/login', pathMatch: 'full' },
  { path: 'azure-auth', component: LoginComponent, data:{isADredirect:true,adType:"Azure"}},
  { path: 'sso-redirect', component: LoginComponent, data: { isADredirect: true, adType: 'OAuth2' } },
  { path: 'forgotpass', redirectTo: 'account-management/forgotpass', pathMatch: 'full' },
  { path: 'account-management/forgotpass', component: ForgotPasswordComponent, canActivate: [LoginGuard] },
  { path: 'online-payment', redirectTo: 'account-management/online-payment', pathMatch: 'full' },
  { path: 'account-management/online-payment', component: OnlinePaymentGuestComponent, canActivate: [LoginGuard] },
  { path: 'payment/redirect', component: PaytmRedirectComponent },
  { path: 'change_loginId', redirectTo: 'account-management/change_loginId', pathMatch: 'full' },
  { path: 'manage_user_pin', redirectTo: 'account-management/manage_user_pin', pathMatch: 'full' },
  { path: 'landing_url', redirectTo: 'account-management/landing_url', pathMatch: 'full' },
  { path: 'telemedicine/videocall', pathMatch: 'full', component: TelemedicineGuestPageComponent },
  { path: 'view_training_videos', redirectTo: 'account-management/view_training_videos', pathMatch: 'full' },
  { path: 'account-management/login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'account-management/loginwithotp', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'account-management/loginwithpin', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'account-management/termsandcondition',component : LoginComponent,canActivate: [LoginGuard]},
  { path: 'account-management/document/:id',component : TncComponent,canActivate: [LoginGuard]},
  { path: 'report-management/quick-download/:user_id/:id',component : QuickDownloadComponent,canActivate: [AuthGuard]},
  { path: 'report-management/quick-download/:user_id',component : QuickDownloadComponent,canActivate: [AuthGuard]},
  {
    path: 'loginwithkiosk', redirectTo: 'account-management/loginwithkiosk', pathMatch: 'full'
  },
  {
    path: 'loginwithotpkiosk', redirectTo: 'account-management/loginwithotpkiosk', pathMatch: 'full'
  },
  { path: 'account-management/qr_login', component: QRLoginComponent},
  { path: 'account-management/qr_scan', component: QRScannerComponent, canActivate: [AuthGuard] },
  { path: 'account-management/loginwithkiosk', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'account-management/loginwithotpkiosk', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'account-management/download-verify/:user_id/:id',component : QuickOTPComponent},
  { path: 'account-management/download-verify/:user_id',component : QuickMobileOtpComponent},
  {
    path: 'crm',
    canActivate: [AuthGuard],
    data: {
      application: 'crm',
      defaultApplication: 'crm',
      menuDef: crmMenuDef,
      routeDef: crmRouteDef,
      breadcrumb: 'crm'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'changepass', component: BaseComponent, children: [
      {
        path: '',
        component: ChangePasswordComponent,
        data: {
          type: "main"
        }
      }
    ]
  },
  {
    path: 'device_auth', component: DeviceAuthComponent
  },
  {
    path: 'tesseract', component: TesseractComponent
  },
  {
    path: 'authenticate_pin', component: PinAuthenticatedComponent
  },
  {
    path: 'landing_url', component: BaseComponent, children: [
      {
        path: '',
        component: LandingUrlComponent,
        data: {
          type: "main"
        }
      }
    ]
  },
  {
    path: 'support', component: BaseComponent, children: [
      {
        path: '',
        component: SupportComponent,
        data: {
          type: "main"
        },
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'release-notes', component: BaseComponent, children: [
      {
        path: '',
        component: ReleaseNoteComponent,
        data: {
          type: "main"
        },
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'release-notes/:id', component: BaseComponent, children: [
      {
        path: '',
        component: ReleaseNoteComponent,
        data: {
          type: "main"
        },
        canActivate: [AuthGuard]
      }
    ]
  },
  {

    path: '', component: BaseComponent, children: [

      {
        path: 'account-management/dashboard',
        component: DashBoardComponent,
        data: {
          type: "main"
        },
        canActivate: [AuthGuard]
      },
      {
        path: 'account-management/dash-board',
        component: DashBoardComponent,
        data: {
          type: "main"
        },
        canActivate: [AuthGuard]
      }
    ],
    data: {
      application: 'account-management'
    }
  },
  {
    path: 'account-management',
    canActivate: [AuthGuard],
    data: {
      application: 'account-management',
      defaultApplication: 'account',
      menuDef: accountManagementMenuDef,
      routeDef: accountManagementRouteDef,
      breadcrumb: 'Accounts'
    },
    loadChildren: () => import('../modules/account-management/account-management.module').then(m => m.AccountManagementModule)
  },
  {
    path: 'kxinsights',
    canActivate: [AuthGuard],
    data: {
      application: 'kxinsights',
      defaultApplication: 'bi_dashboard',
      menuDef: kxinsightsMenuDef,
      routeDef: kxinsightsRouteDef,
      breadcrumb: 'kxinsights'
    },
    loadChildren: () => import('../modules/kxinsights/kxinsights.module').then(m => m.KxInsightsModule)
  },
  {
    path: 'data-onboarding',
    canActivate: [AuthGuard],
    data: {
      application: 'data-onboarding',
      defaultApplication: 'bulk_upload_permissions',
      menuDef: DataOnBoardingMenuDef,
      routeDef: DataOnBoardingRouteDef
    },
    loadChildren: () => import('../modules/data-onboarding/data-onboarding.module').then(m => m.DataOnboardingModule)
  },
  {
    path: 'order',
    canActivate: [AuthGuard],
    data: {
      application: 'order',
      defaultApplication: 'order',
      menuDef: orderMenuDef,
      routeDef: orderRouteDef,
      breadcrumb: 'order'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: "helpdeskmgmt",
    canActivate: [AuthGuard],
    data: {
      application: 'helpdeskmgmt',
      defaultApplication: 'dashboard',
      routeDef: helpdeskmgmtRouteDef
    },  
    loadChildren: () => import('../modules/helpdesk/helpdesk.module').then(m => m.HelpdeskModule)
  },
  {
    path: "serviceworkflow",
    canActivate: [AuthGuard],
    data: {
      application: 'serviceworkflow',
      defaultApplication: 'serviceworkflow',
      menuDef: serviceWorkflowMenuDef,
      routeDef: serviceWorkflowRouteDef,
    },  
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'bireports',
    canActivate: [AuthGuard],
    data: {
      application: 'bireports',
      defaultApplication: 'bireports',
      menuDef: biReportsMenuDef,
      routeDef: biReportsRouteDef,
      breadcrumb: 'Reports'
    },
    loadChildren: () => import('../modules/bireports/bireports.module').then(m => m.BireportsModule)
  },
  {
    path: 'facility-management',
    canActivate: [AuthGuard],
    data: {
      application: 'facility-management',
      defaultApplication: 'facility',
      menuDef: facilityManagementMenuDef,
      routeDef: facilityManagementRouteDef,
      breadcrumb: 'Facility'
    },
    loadChildren: () => import('../modules/facility-management/facility-management.module').then(m => m.FacilityManagementModule)
  },
  {
    path: 'patient-registration',
    canActivate: [AuthGuard],
    data: {
      application: 'patient-registration',
      defaultApplication: 'patient',
      menuDef: patientMenuDef,
      routeDef: patientRouteDef,
      breadcrumb: 'Patient List'
    },
    loadChildren: () => import('../modules/patient-registration/patient-registration.module').then(m => m.PatientRegistrationModule)
  },
  {
    path: 'adt',
    canActivate: [AuthGuard],
    data: {
      application: 'adt',
      defaultApplication: 'encounter_format', //change here :: TODO
      menuDef: adtMenuDef,
      routeDef: adtRouteDef,
      breadcrumb: 'ADT'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'emr',
    canActivate: [AuthGuard],
    data: {
      application: 'emr',
      defaultApplication: 'patientlist_format',
      menuDef: emrMenuDef,
      routeDef: emrRouteDef,
      breadcrumb: 'EMR'
    },
    loadChildren: () => import('../modules/emr/emr.module').then(m => m.EMRModule)
  },
  {
    path: 'billing',
    canActivate: [AuthGuard],
    data: {
      application: 'billing',
      defaultApplication: 'billingdashboard_format',
      menuDef: billingMenuDef,
      routeDef: billingRouteDef,
      breadcrumb: 'Billing'
    },
    loadChildren: () => import('../modules/billing/billing.module').then(m => m.BillingModule)
  },
  {
    path: 'diagnostic',
    canActivate: [AuthGuard],
    data: {
      application: 'diagnostic',
      defaultApplication: 'pathologyDefinition',
      menuDef: diagnosticMenuDef,
      routeDef: diagnosticRouteDef,
      breadcrumb: 'Diagnostic'
    },
    loadChildren: () => import('../modules/diagnostics/diagnostics.module').then(m => m.DiagnosticsModule)
  },
  {
    path: 'bpmn',
    canActivate: [AuthGuard],
    data: {
      application: 'bpmn',
      defaultApplication: 'bpmn_connector',
      menuDef: bpmnMenuDef,
      routeDef: bpmnRouteDef,
      breadcrumb: 'bpmn'
    },
    loadChildren: () => import('../modules/diagnostics/diagnostics.module').then(m => m.DiagnosticsModule)
  },
  // {
  //   path: 'sample-layout',
  //   canActivate: [AuthGuard],
  //   data: {
  //     application: 'sample-layout',
  //     defaultApplication: 'samplelayout',
  //     menuDef: sampelMenuDef,
  //     routeDef: sampleRouteDef
  //   },
  //   loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  // },
  {
    path: 'inventory-management',
    canActivate: [AuthGuard],
    data: {
      application: 'inventory-management',
      defaultApplication: 'item',
      menuDef: inventoryMenuDef,
      routeDef: inventoryRouteDef,
      breadcrumb: 'Inventory Management'
    },
    loadChildren: () => import('../modules/inventory-management/inventory-management.module').then(m => m.InventoryManagementModule)
  },
  {
    path: 'system-management',
    canActivate: [AuthGuard],
    data: {
      application: 'system-management',
      defaultApplication: 'valueset_karexpert',
      menuDef: systemManagementMenuDef,
      routeDef: systemManagementRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },

  {
    path: 'house-keeping',
    canActivate: [AuthGuard],
    data: {
      application: 'house-keeping',
      defaultApplication: 'house_keeping',
      menuDef: houseKeepingMenuDef,
      routeDef: houseKeepingRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'diet-kitchen',
    canActivate: [AuthGuard],
    data: {
      application: 'diet-kitchen',
      defaultApplication: 'diet_plan_format',
      menuDef: dietKitchenMenuDef,
      routeDef: dietKitchenRouteDef
    },
    loadChildren: () => import('../modules/diet-kitchen/diet-kitchen.module').then(m => m.DietKitchenModule)
  },
  {
    path: 'mrd',
    canActivate: [AuthGuard],
    data: {
      application: 'mrd',
      defaultApplication: 'files_format',
      menuDef: mrdMenuDef,
      routeDef: mrdRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'misreports',
    canActivate: [AuthGuard],
    data: {
      application: 'misreports',
      defaultApplication: 'admission_reports',
      menuDef: misReportsMenuDef,
      routeDef: misReportsRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'pharmacy',
    canActivate: [AuthGuard],
    data: {
      application: 'pharmacy',
      defaultApplication: 'ipMedicationOrder',
      menuDef: pharmacyMenuDef,
      routeDef: pharmacyRouteDef,
      breadcrumb: 'Pharmacy'
    },
    loadChildren: () => import('../modules/pharmacy/pharmacy.module').then(m => m.PharmacyModule)
  },
  {
    path: 'optical',
    canActivate: [AuthGuard],
    data: {
      application: 'optical',
      defaultApplication: 'opOpticalOrders',
      menuDef: opticalMenuDef,
      routeDef: opticalRouteDef
    },
    loadChildren: () => import('../modules/optical/optical.module').then(m => m.OpticalModule)
  },
  {
    path: 'cssd',
    canActivate: [AuthGuard],
    data: {
      application: 'cssd',
      defaultApplication: 'request_list',
      menuDef: CssdMenuDef,
      routeDef: CssdRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'system-settings',
    canActivate: [AuthGuard],
    data: {
      application: 'system-settings',
      defaultApplication: 'constantValueSet',
      menuDef: systemSettingsMenuDef,
      routeDef: systemSettingsRouteDef,
      breadcrumb: 'Constant Value Set'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'linen-laundry',
    canActivate: [AuthGuard],
    data: {
      application: 'linen-laundry',
      defaultApplication: 'indent_raised',
      menuDef: LinenLaundryMenuDef,
      routeDef: LinenLaundryRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'nhm-reports',
    canActivate: [AuthGuard],
    data: {
      application: 'nhm-reports',
      defaultApplication: 'nhm',
      menuDef: nhmMenuDef,
      routeDef: nhmRouteDef,
      breadcrumb: 'NHM Reports'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'emergency',
    canActivate: [AuthGuard],
    data: {
      application: 'emergency',
      defaultApplication: 'emergency_format',
      menuDef: emergencyMenuDef,
      routeDef: emergencyRouteDef,
      breadcrumb: 'EMERGENCY'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'payment',
    canActivate: [AuthGuard],
    data: {
      application: 'payment',
      defaultApplication: 'deposit',
      menuDef: paymentMenuDef,
      routeDef: paymentRouteDef,
      breadcrumb: 'Payment'
    },
    loadChildren: () => import('../modules/payment/payment.module').then(m => m.PaymentModule)
  },
  // {
  //   path: 'pharmacy',
  //   canActivate: [AuthGuard],
  //   data: {
  //     application: 'pharmacy',
  //     defaultApplication: 'ipMedicationOrder',
  //     menuDef: pharmacyMenuDef,
  //     routeDef: pharmacyRouteDef,
  //     breadcrumb: 'Pharmacy'
  //   },
  //   loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  // },
  {
    path: 'appointment',
    canActivate: [AuthGuard],
    data: {
      application: 'appointment',
      defaultApplication: 'appointment',
      menuDef: appointmentMenuDef,
      routeDef: appointmentRouteDef,
      breadcrumb: 'Appointments'
    },
    loadChildren: () => import('../modules/appointment/appointment.module').then(m => m.AppointmentModule)
  },
  {
    path: 'emr',
    canActivate: [AuthGuard],
    data: {
      application: 'emr',
      defaultApplication: 'patientlist_format',
      menuDef: emrMenuDef,
      routeDef: emrRouteDef,
      breadcrumb: 'EMR'
    },
    loadChildren: () => import('../modules/emr/emr.module').then(m => m.EMRModule)
  },
  {
    path: 'form-template-engine',
    canActivate: [AuthGuard],
    data: {
      application: 'form-template-engine',
      defaultApplication: 'template',
      menuDef: templateMenuDef,
      routeDef: templateRouteDef,
      breadcrumb: 'Template'
    },
    loadChildren: () => import('../modules/feedback/feedback.module').then(m => m.FeedbackModule)
  },
  {
    path: 'ot',
    canActivate: [AuthGuard],
    data: {
      application: 'ot',
      defaultApplication: 'schedule_event_ot',
      menuDef: otMenuDef,
      routeDef: otRouteDef,
      breadcrumb: 'OT'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'ambulance-management',
    canActivate: [AuthGuard],
    data: {
      application: 'ambulance-management',
      defaultApplication: 'ambulance_dashboard',
      menuDef: ambulanceMenuDef,
      routeDef: ambulanceRouteDef,
      breadcrumb: 'Ambulance'
    },
    loadChildren: () => import('../modules/ambulance/ambulance.module').then(m => m.AmbulanceModule)
  },
  {
    path: 'demo-application',
    canActivate: [AuthGuard],
    data: {
      application: 'demo-application',
      defaultApplication: 'project_summary',
      menuDef: demoapplicationMenuDef,
      routeDef: demoapplicationRouteDef,
      breadcrumb: 'Demo Application'
    },
    loadChildren: () => import('../modules/ambulance/ambulance.module').then(m => m.AmbulanceModule)
  },
  {
    path: 'queue-management',
    canActivate: [AuthGuard],
    data: {
      application: 'queue-management',
      defaultApplication: 'consultation_queue_management',
      menuDef: queueViewMenuDef,
      routeDef: queueViewRouteDef,
      breadcrumb: 'QueueView'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'dms',
    canActivate: [AuthGuard],
    data: {
      application: 'dms',
      defaultApplication: '',
      menuDef: dmsMenuDef,
      routeDef: dmsRouteDef,
      breadcrumb: 'DMS'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'alertmanager',
    canActivate: [AuthGuard],
    data: {
      application: 'alertmanager',
      defaultApplication: 'event_master',
      menuDef: alertMenuDef,
      routeDef: alertRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'scheduler',
    canActivate: [AuthGuard],
    data: {
      application: 'scheduler',
      defaultApplication: 'custom_scheduler',
      menuDef: schedulerMenuDef,
      routeDef: schedulerRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'integrator',
    canActivate: [AuthGuard],
    data: {
      application: 'integrator',
      defaultApplication: 'integrator_mastr',
      menuDef: integratorMenuDef,
      routeDef: integratorRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'abdm-integration',
    canActivate: [AuthGuard],
    data: {
      application: 'abdm-integration',
      defaultApplication: 'integrator_mastr',
      menuDef: abdmintegratorMenuDef,
      routeDef: abdmintegratorRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'report-management',
    canActivate: [AuthGuard],
    data: {
      application: 'report-management',
      defaultApplication: 'report-management',
      menuDef: ReportManagementMenuDef,
      routeDef: ReportManagementRouteDef,
      breadcrumb: 'report-management'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'formbuilder',
    canActivate: [AuthGuard],
    data: {
      application: 'form-builder',
      defaultApplication: 'form-builder',
      menuDef: formBuilderMenuDef,
      routeDef: formBuilderRouteDef,
      breadcrumb: 'formBuilder'
    },
    loadChildren: () => import('../modules/formBuilder/formBuilder.module').then(m => m.FormBuilderModule)
  }, 
  {
    path: 'my-bills',
    canActivate: [AuthGuard],
    data: {
      application: 'billing',
      defaultApplication: 'patient_bill',
      menuDef: myBillsMenuDef,
      routeDef: myBillsRouteDef,
      breadcrumb: 'myBills'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },{
    path: 'discovery',
    canActivate: [AuthGuard],
    data: {
      application: 'discovery',
      defaultApplication: 'discovery_application',
      menuDef: discoveryMenuDef,
      routeDef: discoveryRouteDef,
      breadcrumb: 'discovery'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'insurance',
    canActivate: [AuthGuard],
    data: {
      application: 'insurance',
      defaultApplication: 'insurance_beneficiary_format',
      menuDef: insuranceMenuDef,
      routeDef: insuranceRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'rule-engine',
    canActivate: [AuthGuard],
    data: {
      application: 'rule-engine',
      defaultApplication: 'rule',
      menuDef: ruleEngineMenuDef,
      routeDef: ruleEngineRouteDef
    },
    loadChildren: () => import('../modules/rule-engine/rule-engine.module').then(m => m.RuleEngineModule)
  },
  {
    path: 'payment-gateway',
    canActivate: [AuthGuard],
    data: {
      application: 'payment-gateway',
      defaultApplication: 'payment-gateway',
      menuDef: paymentGatewayMenuDef,
      routeDef: paymentGatewayRouteDef,
      breadcrumb: 'payment-gateway'
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'printengine',
    canActivate: [AuthGuard],
    data: {
      application: 'printengine',
      defaultApplication: 'printengine',
      menuDef: printengineMenuDef,
      routeDef: printengineRouteDef
    },
    loadChildren: () => import('../modules/printengine/printengine.module').then(m => m.PrintEngineModule)
  },
  {
    path: 'seriespattern',
    canActivate: [AuthGuard],
    data: {
      application: 'seriespattern',
      defaultApplication: 'seriespattern',
      menuDef: seriespatternMenuDef,
      routeDef: seriespatternRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'blood-bank',
    canActivate: [AuthGuard],
    data: {
      application: 'blood-bank',
      defaultApplication: 'blood-bank',
      menuDef: bloodBankMenuDef,
      routeDef: bloodBankRouteDef
    },
    loadChildren: () => import('../modules/blood-bank/components/blood-bank.module').then(m => m.BloodBankModule)
  },
  {
    path: 'misbuilder',
    canActivate: [AuthGuard],
    data: {
      application: 'misbuilder',
      defaultApplication: 'misbuilder',
      menuDef: misBuilderMenuDef,
      routeDef: misBuilderRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'master-management',
    canActivate: [AuthGuard],
    data: {
      application: 'master-management',
      defaultApplication: 'master-management',
      menuDef: masterManagementMenuDef,
      routeDef: masterManagementRouteDef,
      breadcrumb: 'master-management'
    },
    loadChildren: () => import('../modules/master-management/master-management.module').then(m=>m.MasterManagementModule)
  },
  {
    path: 'chatbot',
    canActivate: [AuthGuard],
    data: {
      application: 'chatbot',
      defaultApplication: 'chatbot',
      menuDef: chatbotMenuDef,
      routeDef: chatbotRouteDef
    },
    loadChildren: () => import('../modules/chatbot/chatbot.module').then(m => m.ChatBotModule)
  },
  {
    path: 'aiml-gateway',
    canActivate: [AuthGuard],
    data: {
      application: 'aiml-gateway',
      defaultApplication: 'aiml-gateway',
      menuDef: aiMlGatewayMenuDef,
      routeDef: aiMlGatewayRouteDef
    },
    loadChildren: () => import('../modules/default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'opsmgmt',
    canActivate: [AuthGuard],
    data: {
      application: 'opsmgmt',
      defaultApplication: 'opsmgmt',
      menuDef: opsMgmtMenuDefs,
      routeDef: opsMgmtRouteDefs,
      breadcrumb: 'Operation Management'
    },
    loadChildren: () => import('../modules/opsmgmt/opsmgmt.module').then(m => m.OpsMgmtModule)
  },
    {
    path: 'care-plan',
    canActivate: [AuthGuard],
    data: {
      application: 'care-plan',
      defaultApplication: 'care-plan',
      menuDef: carePlanMenuDef,
      routeDef: carePlanRouteDef,
      breadcrumb: 'Care Plan'
    },
    loadChildren: () => import('../modules/care-plan/care-plan.module').then(m => m.CarePlanModule)
  },
  { path: '404', component: P404Component },
  { path: '500', component: P500Component },
  { path: 'offline', component: OfflineComponent },
  {
    // Served by the separate kx-tools app, not by this one. Declared here only
    // so the sidebar's routerLink matches something — the guard then leaves via
    // a real page load so the Ingress (dev: the /tools entry in
    // proxy.conf.json) can route it. Without this the link 404s, because the
    // backend's menu data still lists tools while this app has no such route.
    //
    // The wildcard child is what makes deep links like /tools/ai_agent_factory
    // match; the parent guard cancels navigation before the child resolves.
    path: 'tools',
    canActivate: [ExternalAppGuard],
    children: [{ path: '**', children: [] }]
  },
  { path: '**', redirectTo: '/404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }  
